module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jNNwX"))).then(() => parcelRequire('9Lwss'));